// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap___ZSeh","right":"styles_right__3GoUQ"};